import fs from 'fs';
import path from 'path';

export function loadBase64Image(relativePath: string): string {
    const absolutePath = path.resolve(process.cwd(), relativePath);
    const buffer = fs.readFileSync(absolutePath);
    return `data:image/png;base64,${buffer.toString('base64')}`;
}

export async function fetchSvgBase64(url: string) {
    try {
        const res = await fetch(url);
        const svgText = await res.text();
        // Encode SVG text as base64
        const base64 = Buffer.from(svgText).toString('base64');
        return `data:image/svg+xml;base64,${base64}`;
    } catch (error) {
        console.error('Error fetching SVG:', error);
        return null;
    }
}
